import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            paginate: {},
            refreshAccess: false
        };
    },
    getters: {
        cemeteries: (state) => {
          return state.paginate.hasOwnProperty('data')
            ? state.paginate.data
            : [];
        },
        paginate: (state) => {
            return state.paginate
        },
        refreshAccess: (state) => {
            return state.refreshAccess;
        }
    },
    mutations: {
        setRefreshAccess(state, value) {
            window.Vue.set(state, 'refreshAccess', value);
        },
        setLocationsPaginate(state, value) {
            window.Vue.set(state, 'paginate', value);
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/location', payload)
                    .then((response) => {
                        resolve(response);
                        commit('setLocationsPaginate', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteCemetery({state, commit, getters}, cemetery) {
            return new Promise((resolve, reject) => {
                ApiService.delete('/location/' + cemetery.id)
                    .then((response) => {
                        resolve(response);
                        commit('setRefreshAccess', true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
}